import { connect } from 'react-redux';
import Selector from './Selector';
import { resetCardFilters, setFilters } from '../../../filters/store/filtersSlice';
import { setMobileDrawerOpen } from '../../../mobile-drawer/store/mobileDrawerSlice';

const mapState = state => ({
  selectedIndex: state.loadingManagement.filters.selectedIndex,
});

const mapDispatchToProps = {
  resetCardFilters,
  setFilters,
  setMobileDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(Selector);
